const Env = require('./Env');

module.exports = class Logger {
	constructor (contextName) {
		this.contextName = contextName;
	}

	getContextName () {
		return this.contextName;
	}

	log (...message) {
		if (Env.isDevelopment()) {
			console.log(this.contextName + ":", ...message);
		}
	}
}